import { Texts } from '../../../../hooks/useTexts'

const companySloganMaxLength = 50

export const createValidateCompanySlogan = async (texts: Texts, companySlogan: string) => {
  const companySloganMaxLengthError = {
    id: 'companySloganMaxLengthError',
    field: 'companySlogan',
    message: texts.validations.companySloganMaxLength(companySloganMaxLength),
  }

  const invalid = companySlogan.length > companySloganMaxLength

  return {
    [companySloganMaxLengthError.id]: invalid ? companySloganMaxLengthError : undefined,
  }
}
